import React, { useState } from 'react';
import { IoChevronDownOutline, IoCloseOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom'; // Import for routing
import questionsImg from '../assets/questionsImg.png';

const Questions = () => {
  const [openItem, setOpenItem] = useState(null);
  const navigate = useNavigate(); // Initialize navigate for routing

  const faqItems = [
    {
      id: 1,
      question: "1. एक परिवार एक आरक्षण क्या है?",
      answer: "आरक्षित वर्ग में किसी भी परिवार में आरक्षण के तहत नौकरी का लाभ प्रतिनिधि करने का मौका किसी एक व्यक्ति तक सीमित करना है।"
    },
    {
      id: 2,
      question: "2. एक परिवार एक आरक्षण क्यों आवश्यक है?",
      answer: "वर्तमान में आरक्षण के लाभ लेने में भी परिवार वाद हावी हो गया है। आर्थिक  सम्पन्नता बढ़ जाती है, धन बल, बाहुबल, भाषण बल से एक ही परिवार से कई कई  लोग जन प्रतिनिधि बन जाते हैं, बच्चों को उच्चतर स्तर की शिक्षा की  व्यवस्था करा पाते हैं, जिससे आरक्षित वर्ग के वंचित परिवारों के बच्चों की तुलना में सम्पन्न आरक्षित परिवारों के बच्चे ज्यादा कुशाग्र होते हैं,  अतः नौकरी और जनप्रतिनिधि में प्राथमिकता में आगे हो जाते हैं। यह पुनः  शोषण का विशियस चक्र चलता जाता है। अर्थात आरक्षित सम्पन्न लोग ही आरक्षित  लोगों का शोषण करने लगते हैं।"
    },
    {
      id: 3,
      question: "3. परिवार में कौन आते हैं?",
      answer: "माता-पिता, पति-पत्नी, भाई-भाभी, बहन-जीजा, बेटे-बहु, नाती-नातिन "
    },
    {
      id: 4,
      question: "4. किस प्रकार के आरक्षण के लाभ को लाभ माना जायेगा?",
      answer: "आरक्षण के तहत प्राप्त किसी भी प्रकार की नौकरी और जन प्रतिनिधि का चयन होना सरपंच, BDC सदस्य, जिला पंचायत सदस्य, विधायक और सांसद निर्वाचित होना।"
    },
    {
      id: 5,
      question: "5. क्या एक बार चुनाव जीतने के बाद पुनः चुनाव लड़ सकता है?",
      answer: "आरक्षण के तहत किसी भी स्तर का चुनाव कोई भी व्यक्ति एक बार भी जीत जाए पुनः उसी  स्तर का चुनाव स्वयं या परिवार का कोई भी अन्य सदस्य भाग नहीं ले सकेगा।"
    },
    {
      id: 6,
      question: "6. सरपंच का चुनाव जीत कर क्या अन्य पद का चुनाव लड़ सकता है?",
      answer: "हां, सरपंच का चुनाव जीतने के बाद वह या उनके परिवार का कोई भी सदस्य सरपंच को छोड़कर किसी अन्य दायित्व हेतु चुनाव लड़ सकते है।  अर्थात किसी भी परिवार से सरपंच, BDC, जिला पंचायत, स्थानीय निकाय, विधायक या  सांसद के रूप में एक - एक बार ही चुनाव जीत सकते हैं । जिस किसी भी पद का  प्रतिनिधित्व एक बार हो गया पुनः उसी पद हेतु परिवार से कोई भी चुनाव नहीं  लड़ सकत।"
    },
    {
      id: 7,
      question: "7. क्या अनारक्षित सीट से चुनाव लड़ सकते हैं?",
      answer: "हां, अनारक्षित सीट से कितनी भी बार चुनाव लड़ सकते हैं और जीत भी सकते हैं।।"
    },
    {
      id: 8,
      question: "8. क्या अनारक्षित सीट से नौकरी भी प्राप्त कर सकते हैं?",
      answer: "हां, ऐसे परिवार के लोग अनारक्षित पदों हेतु नौकरी प्राप्त करने के योग्य  होंगे, बशर्तें वो प्रतिभागियों की योग्यता में चयनित किए गए हों"
    },
    {
      id: 9,
      question: "9. एक परिवार एक आरक्षण क्या विभिन्न संस्थाओं में भी लागू होगा?",
      answer: "नहीं, किसी विद्यालय, कॉलेज के एडमिशन में लागू नहीं होगा।"
    },
    {
      id: 10,
      question: "10. क्या बार बार एक परिवार अपनी स्थिति बदल कर किसी प्रकार के अनुसूचित वर्ग का आरक्षण लागू होगा?",
      answer: "नहीं, स्वयं के रोजगार हेतु व्यापार, उद्योग हेतु आर्थिक लाभ या सहायता या लोन पर यह व्यवस्था लागू नहीं होगी।"
    },
    {
      id: 11,
      question: "11. एक परिवार एक आरक्षण में किसी एक सदस्य के सम्मिलित होने से परिवार के अन्य सदस्य का उसके समान के साथ सम्बन्ध होगा?",
      answer: "यदि एक परिवार एक आरक्षण लागू नहीं किया गया तो आरक्षित वर्गों के वंचित  परिवारों के साथ अन्याय को रोक नहीं पाएंगे। सामाजिक भेद भाव को दूर करने  का यही एक मात्र उपाय ह।"
    },
    {
      id: 12,
      question: "12. समान्य यह है कि भीलवा जन्म से नहीं जाने है?",
      answer: "ऐसी मान्यता गलत है, शोषण करने वाले सिर्फ शोषक होते हैं, शोषण का सम्पन्नता  या गरीबी से कोई सरोकार नहीं होता। आज आरक्षित श्रेणी से शासन और प्रशासन  में कितने ही लोग अपने ही आरक्षित जाती के लोगों के हितों पर कुठाराघात कर  रहे हैं, उनकी जमीनें औने पौने दामों पर संग्रहित कर रहे हैं। समाज के  ठेकेदार बन गए हैं। दल बदल करते हैं। पैसे वालों के लिए नियम बनाते या लागू करते हैं।"
    },
    {
      id: 13,
      question: "13. गोत्र किस लिहाज जोड़ा करते है?",
      answer: "समाज में शोषण करने वाले और शोषित होने वाले सिर्फ दो जातियां ही होती हैं।  इसलिए बारी - बारी से वंचितों में से सबको मौका मिले ऐसी व्यवस्था बनानी  होगी।"
    },
    {
      id: 14,
      question: "14. महिला, श्रीमान और उनका कार्य को भोजन करने वाला क्या कहा जाता है?",
      answer: "यह मान्यता गलत है, यदि ऐसा होता तो संविधान सभा में उच्च वर्गों की बहुलता  होने के बाद भी आरक्षण की व्यवस्था कैसे स्वीकार कर ली गई ।इतना ही नहीं हर 10 वर्षों में आरक्षण के विषय को संसद में सर्वसम्मति से बढ़ाया जाता रहा  है, यह भी स्वर्णों के सहयोग के बिना कैसे संभव होगा।"
    },
    {
      id: 15,
      question: "15. क्या है और असली व्यवस्था क्या है?",
      answer: "भारतीय संस्कृति में छुआछूत का कोई स्थान नहीं रहा है, यह शोषण करने वालों की चाल रही है, जिसे वर्तमान युवा अच्छी तरह से समझने लगी है।"
    },
    {
      id: 16,
      question: "16. क्या साहब का सवाल के बाद के बेटा बाद कर?",
      answer: "बाबा साहब को अंबेडकर का नाम उनके ब्राम्हण शिक्षक ने ही दिया था, बाबा साहब को उच्च शिक्षा हेतु विदेश पढ़ने के लिए भेजने वाले भी स्वर्ण राजा ही थे।  इतना ही नहीं बाबा साहब ने संविधान सभा में स्पष्ट कहा था, सामाजिक भेद भाव सिर्फ कानून से दूर नहीं किया जा सकता जब तक वृहद समाज भेद भाव को  अस्वीकार न कर दे। इसलिए सामाजिक चेतना और जागृति आवश्यक है"
    },
    {
      id: 17,
      question: "17. क्या ग्राम, नए ग्राम का नाम लिखना पड़ी है?",
      answer: "यह देश को तोड़ने, वंचितों को एक जुट होने, उनके अधिकारों की आवाज बुलंद करने से भटकाना है। बाबा साहब की पुस्तक भारत का बटवारा को पढ़ने से ऐसे नारा  लगाने वालों के मंसूबे का पता चलता है। ये लोग समाज के ठेकेदार बन कर  राजनीतिक दलों के साथ मोल भाव करते हैं।"
    }
  ];

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <div id="questions" className="flex flex-col lg:flex-row min-h-screen bg-[#F3F5F6] relative">
      {/* Go Back Button */}
      <button
        onClick={() => navigate('/')} // Navigate back to the homepage
        className="absolute top-4 left-4 bg-blue-600 text-white px-4 py-2 rounded-md shadow hover:bg-blue-700 transition"
      >
        Go Back
      </button>

      {/* Left side illustration */}
      <div className="lg:w-1/2 w-full p-8 flex items-center justify-center">
        <img
          src={questionsImg}
          alt="FAQ Illustration"
          className="max-w-full h-auto rounded-lg"
        />
      </div>

      {/* Right side FAQ section */}
      <div className="lg:w-3/5 w-full p-8">
        <div className="bg-white rounded-lg shadow-lg p-6">
          {/* Top Heading */}
          <h1 className="font-inter font-bold text-2xl md:text-3xl text-[#525560] mb-6">
            सामान्यतः पूछे जाने वाले प्रश्न
          </h1>

          {/* Scrollable FAQ container */}
          <div className="max-h-[calc(100vh-200px)] overflow-y-auto pr-4">
            {faqItems.map((item) => (
              <div key={item.id} className="mb-4 border-b border-gray-200 last:border-0">
                <button
                  className="w-full flex justify-between items-center py-4 text-left focus:outline-none"
                  onClick={() => toggleItem(item.id)}
                >
                  <span className="font-extrabold text-gray-700 text-lg">{item.question}</span>
                  {openItem === item.id ? (
                    <IoCloseOutline className="w-6 h-6 text-gray-500" />
                  ) : (
                    <IoChevronDownOutline className="w-6 h-6 text-gray-500" />
                  )}
                </button>
                
                {openItem === item.id && (
                  <div className="pb-4 text-gray-600">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Questions;
